import { render, staticRenderFns } from "./ClinicOrderDetail.vue?vue&type=template&id=50a7b331&"
import script from "./ClinicOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOrderDetail.vue?vue&type=style&index=0&id=50a7b331&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports